import { Injectable } from '@angular/core';
import { BlogDataModel, SingelBlogModel, CategoriesModel } from '@shared/models/blog.model';
import { homePageData, blogData } from '@shared/data/blog/blog-basic/split';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlogDataService {
  public homeBlogData = homePageData;
  public mainBlogData = blogData;
  public selectedCategoryData: BlogDataModel;
  public allBlogPressedData: BlogDataModel = { cImages: [], category: 'all', name: 'מאמרים', data: [] };
  public selectedArticle: SingelBlogModel;
  public allCategories: CategoriesModel[] = [{ name: 'כל המאמרים', category: 'all' }];
  public galleryCategory: CategoriesModel[] = [];
  public dataUpdated$: Subject<BlogDataModel> = new Subject();


  constructor() {
    this.selectedCategoryData = this.mainBlogData[0];
    this.setBlogPressedData();
  }

  setBlogPressedData() {
    blogData.forEach(cate => {
      this.allBlogPressedData.data = this.allBlogPressedData.data.concat(cate.data);
      this.allCategories.push({ name: cate.name, category: cate.category });
      if (cate.category !== 'all' && cate.category !== 'thought') {
        this.galleryCategory.push({ name: cate.name, category: cate.category });
      }

    });
  }

  setSelectedCategory(type: string) {
    if (type !== 'all') {
      this.selectedCategoryData = this.mainBlogData.find(category => category.category === type);
    } else {
      this.selectedCategoryData = {
        cImages: [
          { url: 'assets/images/traces/nimia1.jpg', description: 'עיקבות נמייה' },
          { url: 'assets/images/traces/zvi1.jpg', description: 'עיקבות צבי' },
          { url: 'assets/images/traces/boar1.jpg', description: ' עקבות חזיר בר' },
          { url: 'assets/images/traces/fox1.jpg', description: 'עיקבות שועל מצוי' },
        ], category: 'all', name: 'מאמרים', data: this.allBlogPressedData.data
      };
    }
    this.dataUpdated$.next(this.selectedCategoryData);
  }

  selectBlogPostById(id) {
    return blogData.find(x => x.category === 'thought').data.find(p => p.Id == id);
  }

}
